/* Sahajan quiz result pages.

   Everything here is behaviour only. Not one price, product name or claim lives
   in this file: the sections render all of that from Shopify, and this reads it
   back off the page. So a price change in Shopify needs no change here.

   What it does:
     1. writes the visitor's first name into the heading, from the web address
     2. the sideways product gallery and its thumbnail strip
     3. the step-by-step ritual builder, the running basket, and the checkout link
     4. the two offers: money off a bigger basket, and a free gift. Both are read
        from the Bundle Builder's own settings and both are carried out by a real
        Shopify discount code put on the checkout link. Nothing is invented here:
        no code in the settings means no offer, and no wording about one either.
     5. the bar that follows the screen
     6. the ingredients pop-up
     7. the arrows on the customer photo strip

   Written plainly on purpose, no framework, no build step. It has to be readable
   by whoever picks this up next.
*/
(function () {
  "use strict";

  var $ = function (sel, root) { return (root || document).querySelector(sel); };
  var $$ = function (sel, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(sel));
  };

  /* ---------------------------------------------------------------- 1. name --
     The quiz sends people to .../pages/your-result?name=Priya. Liquid cannot see
     a query string, so the heading carries both versions and we pick one here.
     No name in the address is a normal case, not an error: the page then reads
     "Your Calm Brightening Ritual".                                          */
  function personalise() {
    var name = new URLSearchParams(location.search).get("name");
    if (name) { name = name.trim().slice(0, 40); }
    var h = $("h1[data-name-template]");
    if (h) {
      var line = name
        ? h.getAttribute("data-name-template").replace("[name]", name)
        : h.getAttribute("data-no-name");
      /* Only the first row is rewritten. The ritual name below it is its own
         highlighted span, and writing to the whole heading would delete it. */
      var lead = $("[data-title-lead]", h);
      if (lead) { lead.textContent = line; } else { h.textContent = line; }
    }

    /* The green offer bar carries the same name. The name is put in as a text
       node, never as markup, so a name in the address can never become HTML. */
    var slot = $("[data-annbar-text]");
    if (slot) {
      var line = name ? slot.getAttribute("data-named") : slot.getAttribute("data-plain");
      slot.textContent = "";
      if (name && line.indexOf("[name]") !== -1) {
        var bits = line.split("[name]");
        var bold = document.createElement("b");
        bold.textContent = name;
        slot.appendChild(document.createTextNode(bits[0]));
        slot.appendChild(bold);
        slot.appendChild(document.createTextNode(bits.slice(1).join("[name]")));
      } else {
        slot.textContent = line;
      }
    }
    swapYour(name);
  }

  /* Every other heading says "Your Ritual", "Your Three Steps" and so on. With a
     name in the address those become "Priya's Ritual". The original wording is
     kept on the element, so this is safe to run twice and reads normally for the
     people who arrive without a name. */
  function swapYour(name) {
    if (!name) return;
    var owner = name.replace(/\s+$/, "") + "'s";
    $$("h1, h2, h3").forEach(function (el) {
      if (el.hasAttribute("data-name-template")) return;   // the h1 is done above
      if (el.children.length) return;                      // leave mixed markup alone
      var was = el.getAttribute("data-your-original");
      if (was === null) { was = el.textContent; el.setAttribute("data-your-original", was); }
      if (!/\bYour\b/.test(was)) return;
      el.textContent = was.replace(/\bYour\b/g, owner);
    });
  }

  /* ------------------------------------------------------------- 2. gallery --
     She swipes or scrolls the strip sideways, or taps a thumbnail. No arrows on
     the picture: they sat on top of the product. The thumbnail outline follows
     whichever shot has settled in the frame.                                  */
  function wireGalleries() {
    $$("[data-gallery]").forEach(function (frame) {
      var pic = frame.parentNode;
      var imgs = $$("img", frame);
      var thumbs = $$(".thumb", pic);
      if (imgs.length < 2) return;

      var at = -1;
      function mark(n) {
        if (n === at) return;
        at = n;
        thumbs.forEach(function (b, k) { b.classList.toggle("on", k === n); });
        var a = thumbs[n];
        /* Move the thumbnail strip itself, never the page. scrollIntoView walks
           up to the nearest scrollable ancestor, and on load that is the
           document, which is what was dropping people halfway down the page. */
        var strip = a && a.parentNode;
        if (strip && strip.scrollWidth > strip.clientWidth + 1) {
          strip.scrollLeft = a.offsetLeft - (strip.clientWidth - a.offsetWidth) / 2;
        }
      }

      /* Two signals, either one harmless if the other already fired: an observer
         for the shot that settles in the frame, and a throttled scroll read as
         the backstop. mark() ignores a repeat, so a double call costs nothing. */
      if (window.IntersectionObserver) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            if (e.isIntersecting) mark(+e.target.getAttribute("data-gi"));
          });
        }, { root: frame, threshold: 0.6 });
        imgs.forEach(function (im) { io.observe(im); });
      }

      var tm = null;
      frame.addEventListener("scroll", function () {
        if (tm) return;
        tm = setTimeout(function () {
          tm = null;
          var w = frame.clientWidth || 1;
          mark(Math.max(0, Math.min(imgs.length - 1, Math.round(frame.scrollLeft / w))));
        }, 110);
      }, { passive: true });

      thumbs.forEach(function (b) {
        b.addEventListener("click", function () {
          var n = +b.getAttribute("data-gt");
          /* Chrome pulls a programmatic scroll straight back to the current snap
             point, so snapping comes off for the jump and goes back after. */
          frame.style.scrollSnapType = "none";
          frame.scrollLeft = n * frame.clientWidth;
          frame.style.scrollSnapType = "";
          mark(n);
        });
      });
      mark(0);
    });
  }

  /* ------------------------------------------------------------- 3. builder --
     The ritual arrives already chosen, because the quiz chose it. Everything
     else is opt in.                                                          */
  var builder = $("[data-builder]");
  var openStep = 1;
  var unlocked = false;

  function money(cents) {
    var v = (cents / 100).toFixed(2).replace(/\.00$/, "");
    return "$" + v;
  }

  function items() {
    return $$("[data-item]", builder).filter(function (el) {
      return el.getAttribute("data-on") === "true";
    });
  }

  function priceOf(el) { return parseInt(el.getAttribute("data-price"), 10) || 0; }

  /* Read one setting off the section, with a sane answer when it is empty. */
  function setting(name) { return (builder.getAttribute(name) || "").trim(); }
  function settingNum(name) { return parseFloat(builder.getAttribute(name)) || 0; }

  /* THE TWO OFFERS.
     Each one needs a real Shopify code in the section settings before it counts.
     Without a code the offer is off, the basket shows no saving and the checkout
     link carries none, so the page can never promise what the till will not give.
     The gift is a real product added to the cart; the code is what makes it free. */
  function totals() {
    var chosen = items();
    var gross = chosen.reduce(function (a, el) { return a + priceOf(el); }, 0);

    var pct = settingNum("data-discount-percent");
    /* No basket minimum. The email is what earns it, so an unlocked shopper gets
       the discount whatever the basket size, and a locked one never sees it. */
    var hasDiscount = setting("data-discount-code") !== "" && pct > 0 && unlocked;
    var saving = hasDiscount ? Math.round(gross * (pct / 100)) : 0;

    var giftMin = settingNum("data-gift-min");
    /* The code is optional: a gift priced at zero needs none. The
       Liquid already refuses to show a gift that costs money and has
       no code, so this cannot advertise a gift that gets charged. */
    var hasGift = setting("data-gift-variant") !== "" &&
                  giftMin > 0 && chosen.length >= giftMin;

    return {
      chosen: chosen,
      gross: gross,
      saving: saving,
      total: gross - saving,
      hasDiscount: hasDiscount,
      hasGift: hasGift
    };
  }

  function checkoutUrl(t) {
    if (!t.chosen.length) return "#";
    var parts = t.chosen.map(function (el) {
      return el.getAttribute("data-variant") + ":1";
    });
    /* The gift has to be IN the cart for its code to zero it. It is only ever
       added once the basket has earned it. */
    if (t.hasGift) parts.push(setting("data-gift-variant") + ":1");

    var codes = [];
    if (t.hasDiscount) codes.push(setting("data-discount-code"));
    if (t.hasGift && setting("data-gift-code") !== "") codes.push(setting("data-gift-code"));

    var url = "/cart/" + parts.join(",");
    if (codes.length) url += "?discount=" + codes.map(encodeURIComponent).join(",");
    return url;
  }

  /* The gift line and the saving line, written only when they are earned. */
  function paintOffers(t) {
    var box = $("[data-offers]", builder);
    if (!box) return;
    var rows = "";
    if (t.hasGift) {
      var giftPrice = settingNum("data-gift-price");
      var gicon = document.querySelector("[data-gift-icon]");
      rows += '<div class="offer offer-gift"><span>' +
              (gicon ? gicon.innerHTML : "") +
              esc(setting("data-gift-title")) +
              "<small>" + esc(setting("data-gift-label") || "Free gift") + "</small></span>" +
              "<b>Free" + (giftPrice > 0 ? " <s>" + money(giftPrice) + "</s>" : "") + "</b></div>";
    }
    if (t.hasDiscount) {
      rows += '<div class="offer offer-saving"><span>' +
              esc(setting("data-discount-label")) +
              "</span><b>&minus;" + money(t.saving) + "</b></div>";
    }
    box.innerHTML = rows;
    box.classList.toggle("on", rows !== "");
  }

  function paintSums() {
    $$(".bstep", builder).forEach(function (stepEl) {
      var el = $("[data-sum]", stepEl);
      if (!el) return;
      var on = $$("[data-item]", stepEl).filter(function (i) {
        return i.getAttribute("data-on") === "true";
      });
      if (!on.length) { el.textContent = "Nothing added"; return; }
      var sum = on.reduce(function (a, i) { return a + priceOf(i); }, 0);
      el.textContent = on.length + " added · " + money(sum);
    });
  }

  function recalc() {
    if (!builder) return;
    var t = totals();

    var list = $("[data-list]", builder);
    list.innerHTML = t.chosen.map(function (el) {
      var nm = $(".nm", el).cloneNode(true);
      var role = $("small", nm) ? $("small", nm).textContent : "";
      var title = el.getAttribute("data-name");
      var override = $(".nm", el).childNodes[0];
      if (override && override.textContent.trim()) title = override.textContent.trim();
      return "<li><span>" + esc(title) + "<small>" + esc(role) + "</small></span><b>" +
             money(priceOf(el)) + "</b></li>";
    }).join("");

    var hint = $("[data-hint]", builder);
    if (hint) {
      hint.textContent = t.chosen.length + " in your ritual.";
    }

    paintOffers(t);

    $("[data-total]", builder).textContent = money(t.total);

    var url = checkoutUrl(t);
    $$("[data-checkout]").forEach(function (a) { a.setAttribute("href", url); });

    var bar = $("[data-sticky-note]");
    if (bar) {
      var n = t.chosen.length;
      bar.innerHTML = "<b>" + n + " item" + (n === 1 ? "" : "s") + "</b> &middot; " +
        money(t.total) +
        (t.saving > 0 ? " &middot; <em>save " + money(t.saving) + "</em>" : "") +
        (t.hasGift ? " &middot; <em>free gift</em>" : "");
    }
    /* The sticky button is deliberately NOT pointed at the cart: it
       scrolls to the ritual box so she can check her ritual and unlock
       the 15% off, which is where every other button here sends her. */

    paintSums();
  }

  function esc(s) {
    return String(s).replace(/[&<>"]/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c];
    });
  }

  function wireBuilder() {
    if (!builder) return;

    $$("[data-add]", builder).forEach(function (b) {
      b.addEventListener("click", function () {
        var row = b.closest("[data-item]");
        var on = row.getAttribute("data-on") !== "true";
        row.setAttribute("data-on", String(on));
        row.classList.toggle("on", on);
        b.textContent = on ? "Remove" : "Add";
        recalc();
      });
    });

    $$("header[data-open]", builder).forEach(function (h) {
      h.addEventListener("click", function () {
        var n = +h.getAttribute("data-open");
        openStep = openStep === n ? 0 : n;
        paintOpen();
      });
    });

    $$("[data-done]", builder).forEach(function (b) {
      b.addEventListener("click", function (e) {
        e.stopPropagation();
        openStep = (+b.getAttribute("data-done")) + 1;
        paintOpen();
        var target = $(".bstep.open", builder) || $(".panel", builder);
        if (target) target.scrollIntoView({ block: "center", behavior: "smooth" });
      });
    });

    /* The last group's button label is decided in qr-bundle-builder.liquid
       now (setting "final_label"), so nothing is renamed here. Renaming after
       paint made the old word flash up first. 02/09/2026. */
    paintOpen();
  }

  function paintOpen() {
    $$(".bstep", builder).forEach(function (el) {
      var n = +el.getAttribute("data-n");
      el.classList.toggle("open", n === openStep);
      el.classList.toggle("done", n < openStep);
      var circ = $(".circ", el);
      if (circ) circ.innerHTML = n < openStep ? "&#10003;" : String(n);
    });
    recalc();
  }

  /* -------------------------------------------------------------- 5. sticky --
     Stays hidden until she has read past the builder. After that it is armed for
     good, so scrolling back up still shows it.                                */
  function wireSticky() {
    var bar = $("[data-sticky-bar]");
    var anchor = $("#kit") || $("[data-builder]");
    if (!bar || !anchor) return;
    var armed = false;
    window.addEventListener("scroll", function () {
      if (!armed && anchor.getBoundingClientRect().top < window.innerHeight * 0.75) {
        armed = true;
      }
      bar.classList.toggle("on", armed);
    }, { passive: true });
  }

  /* ---------------------------------------------------------------- 6. modal --
     The ingredients pop-up. Keeps her on the page instead of sending her away. */
  function wireModal() {
    var modal = $("[data-modal]");
    if (!modal) return;
    function close() {
      modal.classList.remove("on");
      document.body.style.overflow = "";
    }
    $$("[data-ingredients]").forEach(function (b) {
      b.addEventListener("click", function () {
        $("[data-modal-title]", modal).textContent = b.getAttribute("data-title") || "";
        $("[data-modal-role]", modal).textContent = b.getAttribute("data-role") || "";
        $("[data-modal-list]", modal).textContent = b.getAttribute("data-list") || "";
        $("[data-modal-note]", modal).textContent = b.getAttribute("data-howto") || "";
        modal.classList.add("on");
        document.body.style.overflow = "hidden";
      });
    });
    $$("[data-modal-close]", modal).forEach(function (x) {
      x.addEventListener("click", close);
    });
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape") close();
    });
  }

  /* --------------------------------------------------------------- 7. wall --- */
  function wireWall() {
    var wall = $("[data-wall]");
    if (!wall) return;
    function scroll(dir) {
      var card = $(".wcard", wall);
      if (card) wall.scrollBy({ left: dir * (card.offsetWidth + 12), behavior: "smooth" });
    }
    var prev = $("[data-wall-prev]");
    var next = $("[data-wall-next]");
    if (prev) prev.addEventListener("click", function () { scroll(-1); });
    if (next) next.addEventListener("click", function () { scroll(1); });

    // Muted preview autoplay, but ONLY while a card is on screen, so a page with
    // four videos never streams all four at once. Off-screen clips are paused,
    // which keeps the data cost to whatever the visitor is actually looking at.
    var io = null;
    if ("IntersectionObserver" in window) {
      io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.play().catch(function () {}); }
          else { e.target.pause(); }
        });
      }, { threshold: 0.5 });
    }

    $$(".wcard", wall).forEach(function (fig) {
      var vid = $("video", fig);
      var play = $(".play", fig);
      // A video slot autoplays, so the static play icon is misleading: hide it.
      if (vid && play) play.style.display = "none";
      if (!vid) return;
      if (io) { io.observe(vid); } else { vid.play().catch(function () {}); }
      // First tap on a card brings the sound and the real controls, then hands
      // the clip fully to the visitor (we stop auto-pausing it on scroll).
      fig.addEventListener("click", function onFirst() {
        vid.muted = false;
        vid.controls = true;
        vid.play().catch(function () {});
        if (io) { io.unobserve(vid); }
        fig.removeEventListener("click", onFirst);
      });
    });
  }

  /* --------------------------------------------------------------- 7. unlock --
     The discount is not given away. She taps the button, the button becomes an
     email box, and the code appears and comes off the total. The code also goes
     on the checkout link, so Shopify applies it for her.

     The email goes to Klaviyo, and the code is only given once Klaviyo has
     accepted it, so nobody gets the discount for an address we never captured. */
  function unlockKey() {
    return "sahajan-unlock:" + setting("data-discount-code");
  }

  /* Klaviyo, wired 18/08. List "PM | Quiz Funnel". */
  var KLAVIYO_KEY = "S2kkET";
  var KLAVIYO_LIST = "WFjrjy";

  function sendEmail(email, done) {
    var attrs = { email: email };
    try {
      var nm = new URLSearchParams(location.search).get("name");
      if (nm) attrs.first_name = nm;
    } catch (e) {}
    /* Which ritual she was shown, so retention can segment on it later. */
    attrs.properties = {
      quiz_ritual: (document.title || "").trim(),
      quiz_page: location.pathname,
      quiz_source: "dark-spot-quiz"
    };
    /* NO "subscriptions" BLOCK HERE, and this is not an oversight. Klaviyo
       answers 400 "'subscriptions' is not a valid field for the resource
       'profile'" if one is sent to this endpoint, and every sign-up then fails
       silently while she is told to try again. /client/subscriptions/ IS the
       subscribe endpoint, so the request itself is the subscription, and the
       consent line under the box is what she agrees to. 18/08. */

    fetch("https://a.klaviyo.com/client/subscriptions/?company_id=" + KLAVIYO_KEY, {
      method: "POST",
      headers: { "Content-Type": "application/json", revision: "2024-10-15" },
      body: JSON.stringify({
        data: {
          type: "subscription",
          attributes: {
            custom_source: "Dark spot quiz result page",
            profile: { data: { type: "profile", attributes: attrs } }
          },
          relationships: { list: { data: { type: "list", id: KLAVIYO_LIST } } }
        }
      })
    }).then(function (r) {
      /* Klaviyo answers 202 with an empty body when it accepts. If it does not,
         she is told to try again rather than being given the code for nothing.
         The reason is written to the console, because a sign-up that fails in
         silence is exactly what went unnoticed on 18/08. */
      if (r.status !== 202 && !r.ok) {
        try {
          r.text().then(function (body) {
            console.warn("Klaviyo refused the sign-up:", r.status, body);
          });
        } catch (e) {}
      }
      done(r.status === 202 || r.ok);
    }, function (e) { console.warn("Klaviyo could not be reached:", e); done(false); });
  }

  function showUnlocked(box) {
    var code = setting("data-discount-code");
    $("[data-unlock-open]", box).hidden = true;
    $("[data-unlock-form]", box).hidden = true;
    $("[data-unlock-consent]", box).hidden = true;
    $("[data-unlock-err]", box).hidden = true;
    $("[data-unlock-code]", box).textContent = code;
    $("[data-unlock-done]", box).hidden = false;
  }

  function wireUnlock() {
    var box = $("[data-unlock]");
    if (!box || !builder) return;

    /* Someone who already traded their email keeps the discount on a reload. */
    try {
      if (window.localStorage && localStorage.getItem(unlockKey()) === "1") {
        unlocked = true;
        showUnlocked(box);
        recalc();
      }
    } catch (e) {}

    $("[data-unlock-open]", box).addEventListener("click", function () {
      this.hidden = true;
      $("[data-unlock-form]", box).hidden = false;
      $("[data-unlock-consent]", box).hidden = false;
      $("[data-unlock-email]", box).focus();
    });

    $("[data-unlock-form]", box).addEventListener("submit", function (e) {
      e.preventDefault();
      var field = $("[data-unlock-email]", box);
      var err = $("[data-unlock-err]", box);
      var email = (field.value || "").trim();
      if (!/^[^@\s]+@[^@\s]+\.[^@\s]{2,}$/.test(email)) {
        err.textContent = "That email does not look right. Check it and try again.";
        err.hidden = false;
        field.focus();
        return;
      }
      err.hidden = true;
      var send = $("button[type=submit]", this);
      send.disabled = true;
      sendEmail(email, function (ok) {
        send.disabled = false;
        if (!ok) {
          err.textContent = "That did not go through. Try again in a moment.";
          err.hidden = false;
          return;
        }
        unlocked = true;
        try { localStorage.setItem(unlockKey(), "1"); } catch (e2) {}
        showUnlocked(box);
        recalc();
      });
    });
  }

  /* ----------------------------------------------------------------- 8. tabs --
     Each product card carries three tabs: how it helps, the botanicals and the
     ingredients. One listener for the whole page, so cards cost nothing extra. */
  function wireTabs() {
    document.addEventListener("click", function (e) {
      var t = e.target.closest ? e.target.closest(".tab") : null;
      if (!t) return;
      var wrap = t.closest("[data-tabs]");
      if (!wrap) return;
      var want = t.getAttribute("data-tab");
      $$(".tab", wrap).forEach(function (x) {
        var on = x === t;
        x.classList.toggle("on", on);
        x.setAttribute("aria-selected", on ? "true" : "false");
      });
      $$(".tabpane", wrap).forEach(function (p) {
        p.classList.toggle("on", p.getAttribute("data-pane") === want);
      });
    });
  }

  function start() {
    personalise();
    wireGalleries();
    wireBuilder();
    wireSticky();
    wireModal();
    wireWall();
    wireUnlock();
    wireTabs();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", start);
  } else {
    start();
  }
})();
